import Vue from 'vue';
import { setupToast } from '@shared/plugins/Toast';

window.eventBus = window.eventBus || new Vue();
Vue.prototype.eventBus = window.eventBus;

setupToast();
